import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const fetchProfile = () => api.get("/profile").then((r) => r.data);
export const fetchContact = () => api.get("/contact").then((r) => r.data);
export const fetchRoles = () => api.get("/roles").then((r) => r.data);
export const fetchProjects = (params = {}) =>
  api.get("/projects", { params }).then((r) => r.data);
export const fetchProject = (slug) =>
  api.get(`/projects/${slug}`).then((r) => r.data);
export const fetchGallery = () => api.get("/gallery").then((r) => r.data);
export const sendContactMessage = (data) =>
  api.post("/contact/message", data).then((r) => r.data);
